import { createContext, useContext } from 'react';
export const InsurancePageContext = createContext(null);
export const useInsurancePageContext = () => useContext(InsurancePageContext);
